export { default as leadModel } from './model';
export type { UpsertAppLeadInput, AppLead } from './types';
export { GET_LEAD_QUIZ_RESULTS, UPSERT_APP_LEAD } from './gql';
